import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Users } from 'lucide-react';
import AdminLayout from '../../../components/admin/AdminLayout';

const PayrollReportsPage = () => {
  const navigate = useNavigate();

  const payrollData = [
    { month: '2024-12', department: 'القسم القانوني', employeeCount: 3, totalSalaries: 45000 },
    { month: '2024-12', department: 'القسم الإداري', employeeCount: 2, totalSalaries: 32300 }
  ];

  const totalSalaries = payrollData.reduce((sum, d) => sum + d.totalSalaries, 0);
  const totalEmployees = payrollData.reduce((sum, d) => sum + d.employeeCount, 0);
  const avgPerEmployee = totalSalaries / totalEmployees;

  return (
    <AdminLayout>
      <div className="p-6 max-w-7xl mx-auto">
        <button onClick={() => navigate('/admin/finance/reports')} className="inline-flex items-center gap-2 text-gray-600 hover:text-[#1E3A8A] mb-4 transition-colors">
          <ArrowRight className="w-5 h-5" /><span className="font-semibold">العودة للتقارير</span>
        </button>
        <h1 className="text-3xl font-black text-[#1E3A8A] mb-6 flex items-center gap-3">
          <Users className="w-8 h-8" /><span>تقارير الرواتب</span>
        </h1>

        <div className="grid grid-cols-3 gap-4 mb-6">
          <div className="bg-white rounded-lg shadow-sm border-2 border-purple-200 p-4">
            <p className="text-sm text-gray-600 mb-1">إجمالي الرواتب</p>
            <p className="text-2xl font-black text-purple-600">{totalSalaries.toLocaleString()} ر.س</p>
          </div>
          <div className="bg-white rounded-lg shadow-sm border-2 border-gray-200 p-4">
            <p className="text-sm text-gray-600 mb-1">عدد الموظفين</p>
            <p className="text-2xl font-black text-gray-700">{totalEmployees}</p>
          </div>
          <div className="bg-white rounded-lg shadow-sm border-2 border-[#C8A870] p-4">
            <p className="text-sm text-gray-600 mb-1">متوسط التكلفة</p>
            <p className="text-2xl font-black text-[#C8A870]">{avgPerEmployee.toLocaleString()} ر.س</p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm border-2 border-gray-200 overflow-hidden">
          <table className="w-full">
            <thead className="bg-gray-50 border-b-2 border-gray-200">
              <tr>
                <th className="px-4 py-3 text-right text-sm font-bold text-gray-700">القسم</th>
                <th className="px-4 py-3 text-center text-sm font-bold text-gray-700">عدد الموظفين</th>
                <th className="px-4 py-3 text-right text-sm font-bold text-gray-700">إجمالي الرواتب</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {payrollData.map((d, i) => (
                <tr key={i} className="hover:bg-gray-50">
                  <td className="px-4 py-3 font-semibold">{d.department}</td>
                  <td className="px-4 py-3 text-center">{d.employeeCount}</td>
                  <td className="px-4 py-3 text-purple-600 font-black text-lg">{d.totalSalaries.toLocaleString()} ر.س</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
};

export default PayrollReportsPage;